<!-- eslint-disable vue/valid-v-model -->
<template>
    <div class="home">
        <Projects />
        <Messages />
        <div v-if="isHistoryMode">
            <HistorySearch />
        </div>
        <div v-else-if="isApproveMode">
            <ApprovePanel />
        </div>
        <div v-else-if="isDeployMode">
            <DeployPanel/>
        </div>
        <div v-else>
<!--            <>-->
            <div v-if="hasCreatePermission">
                <AddTable />
            </div>
            <div class="flex">
                <SearchTable />
<!--                <TableController />-->
            </div>
            <div class="flex">
                <div v-if="env == 'DEV' && hasCreatePermission">
                    <Uploader />
                </div>           
                <Download />
            </div>
            <div v-if="isCountryList"><CompareKey /></div>
            <Table />
            <GoTop />
            <Modal v-show="isModal" />
            <div v-if="isLoading" class="loadingOverlay">
                <img src="@/assets/loading.svg" alt="">
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Projects from '@/components/Home/Projects.vue'
import AddTable from '@/components/Home/AddTable.vue'
import SearchTable from '@/components/Home/SearchTable.vue'
// import TableController from '@/components/Home/TableController.vue'
import Uploader from '@/components/Home/Uploader.vue'
import Download from '@/components/Home/Download.vue'
import Table from '@/components/Home/Table.vue'
import Messages from '@/components/Home/Messages.vue'
import Modal from '@/components/Home/Modal.vue'
import GoTop from '@/components/Home/GoTop.vue'
import CompareKey from '@/components/Home/CompareKey.vue'
import HistorySearch from '@/components/Home/HistorySearch.vue'
import ApprovePanel from '@/components/ApprovePanel.vue'
import DeployPanel from '@/components/DeployPanel.vue'
import { hasSpecifiedPermission, permission } from '@/utils/permission-type';

export default {
    name: 'Home',
    components: {
        Projects,
        AddTable,
        SearchTable,
        // TableController,
        Uploader,
        Download,
        Table,
        Messages,
        Modal,
        GoTop,
        CompareKey,
        HistorySearch,
        ApprovePanel,
        DeployPanel
    },
    computed: {
        ...mapGetters(['isLoading', 'isModal', 'isCountryList', 'isHistoryMode', 'isDeployMode', 'isApproveMode', 'user', 'env']),
        hasCreatePermission() {
            return hasSpecifiedPermission(permission.CREATE, this.user?.permissions ?? [])
        }
    }
}
</script>
<style lang="scss" scoped>
.home {
    padding: 0 1rem;
    @media screen and (min-width: 768px) {
        padding: 0 5rem 5rem;
    }
}
.loadingOverlay {
    width: 100%;
    height: 100%;
    background: rgba($color: #000000, $alpha: .5);
    position: fixed;
    left: 0;
    top: 0;
    z-index: 10;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
        width:50px;
        height:50px;
    }
}
.flex {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
}
</style>
